module.exports = __webpack_public_path__ + "static/media/linkedin.15cf9ebe.svg";